import { supabase } from "@/integrations/supabase/client";
import type { WaitlistFormValues } from "@/lib/waitlistSchema";

/** The only place the `waitlist-signup` function is named. */
export type WaitlistSubmitOutcome = "submitted" | "invalid" | "rate_limited" | "failed";

/**
 * Never throws. supabase-js reports a non-2xx in the result object with the
 * Response on `error.context`, so the status is read from there. A 2xx that is
 * not exactly `{ ok: true }` is a contract violation and reads as failed.
 */
export async function submitWaitlistSignup(values: WaitlistFormValues): Promise<WaitlistSubmitOutcome> {
  try {
    const { data, error } = await supabase.functions.invoke("waitlist-signup", { body: values });
    if (error) {
      const status = (error as { context?: { status?: number } })?.context?.status;
      if (status === 429) return "rate_limited";
      if (status === 400) return "invalid";
      return "failed";
    }
    return (data as { ok?: unknown } | null)?.ok === true ? "submitted" : "failed";
  } catch {
    return "failed";
  }
}
